<section class="page" [class.mobile-page]="isMobileBrowser()" data-testid="appointments-day-time-page">
  <app-page-header
    title="Appointment Day/Time"
    subtitle="Choose first available or your preferred day and time."
    [hideBack]="isModal"
    (back)="onCancel()"></app-page-header>

  <div class="page-content">
    @if (patientCareTeamMember() === null) {
      <app-progress-spinner></app-progress-spinner>
    } @else {
      <form [formGroup]="requestForm" class="form" (ngSubmit)="requestAppointment()">
        <mat-checkbox
          data-testid="first-available-checkbox"
          class="checkbox"
          formControlName="firstAvailable"
          (change)="onFirstAvailableChange($event.checked)">
          First Available
        </mat-checkbox>

        <div class="or-divider">
          <span class="line"></span>
          <span>OR</span>
          <span class="line"></span>
        </div>

        <div formGroupName="dayTime" class="flex flex-col gap-10">
          <div class="flex flex-col gap-4">
            <span class="fw-500">Day(s) of Week</span>
            <span class="flex flex-col">
              <mat-checkbox data-testid="weekday-monday-checkbox" class="checkbox" formControlName="Monday"
                >Monday</mat-checkbox
              >
              <mat-checkbox data-testid="weekday-tuesday-checkbox" class="checkbox" formControlName="Tuesday"
                >Tuesday</mat-checkbox
              >
              <mat-checkbox data-testid="weekday-wednesday-checkbox" class="checkbox" formControlName="Wednesday"
                >Wednesday</mat-checkbox
              >
              <mat-checkbox data-testid="weekday-thursday-checkbox" class="checkbox" formControlName="Thursday"
                >Thursday</mat-checkbox
              >
              <mat-checkbox data-testid="weekday-friday-checkbox" class="checkbox" formControlName="Friday"
                >Friday</mat-checkbox
              >
            </span>
          </div>

          <div class="flex flex-col gap-4">
            <span class="fw-500">Time of Day</span>
            <mat-form-field appearance="outline" data-testid="time-of-day-field">
              <mat-select formControlName="timeOfDay" data-testid="time-of-day-select">
                <mat-option value="early morning">Early Morning</mat-option>
                <mat-option value="morning">Morning</mat-option>
                <mat-option value="afternoon">Afternoon</mat-option>
                <mat-option value="late afternoon">Late Afternoon</mat-option>
              </mat-select>
              @if (requestForm.controls['dayTime'].get('timeOfDay')?.hasError('required') && requestForm.touched) {
                <mat-error id="timeOfDayError"> Required </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        @if (requestForm.errors?.['requiredSelection'] && requestForm.touched) {
          <mat-error id="requiredSelectionError">Please select First Available or at least one weekday. </mat-error>
        }
        @if (!isModal) {
          <div class="btn-container">
            <button id="btnCancel" mat-stroked-button class="error-btn" type="button" (click)="onCancel()">
              Cancel
            </button>
            <button id="btnRequest" mat-flat-button class="primary-btn">Request</button>
          </div>
        }
      </form>
    }
  </div>
</section>
